import Debug from 'debug';
import {LitElement, html, css} from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { extractTextFromScripts, waitWithLogging } from '../utils';
import { sqliteBroker } from '../services/SqliteBroker';

const log = Debug('pdq:sqlite:statement');
@customElement('pdq-sqlite-statement')
export class PdqSqliteStatement extends LitElement {
  static styles = css``;

  @property({ type: String }) database: undefined|string;
  @property({ type: String }) alias = 'main'

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(changedProperties);
  }
  render() {
    return html`
      <slot style="display: none" name="statement" @slotchange="${this._onSlotChange}"></slot>
    `;
  }
  protected async _onSlotChange(event: Event){
    if (!this.database) {
      log(`WARNING: database is not set, statement cannot be applied`)
      return
    }
    try {
      const slot = event.target as HTMLSlotElement;
      const nodes = slot.assignedNodes({ flatten: true });
      const statement = extractTextFromScripts(nodes);


      await waitWithLogging(log, sqliteBroker.getDatabaseReadyPromise(this.database),
        `Waiting for database[${this.database}] to be ready...`)

      const start = performance.now()
      log(`statement changed to ${statement}`);
      const client = await sqliteBroker.getDatabaseClient(this.database, this.alias, `pdq:sqlite:statement`)
      log(`got client`)
      await client.query(statement);
      log(`statement executed in ${performance.now() - start}ms`)

    } catch (e) {
      console.error(`Failed to parse statement`, e);
    }
  }
}